import React from 'react';
import { useSpring, animated } from 'react-spring';
import SidebarButton from '../../common/Buttons/SidebarButton';
import LokalplanInfo from './LokalplanInfo';
import LokalplanList from './LokalplanList';
import { Share } from '../../common/Icons/Regular';
import { ILokalplan } from '../../../Interfaces/ILokalplan';
import { pink, orange } from '../../../style/colors';

export default function LokalplanDetails(props: ILokalplanDetails) {
  const { lokalplan, selected, hoveredPlans } = props;
  const { feature = undefined, delomraader = [], byggefelter = [] } =
    lokalplan || {};
  const { properties = undefined } = feature || {};
  const { doklink = undefined } = properties || {};

  const drawer = useSpring({
    config: { duration: 500 },
    maxHeight: selected ? 2000 : 0,
    overflow: 'hidden',
  });
  const buttonIcon = <Share color="#FFFFFF" width={16} />;
  return (
    <animated.div style={{ ...drawer, ...{ opacity: selected ? 1 : 0 } }}>
      <LokalplanInfo properties={properties} />
      <SidebarButton
        onClick={doklink ? () => window.open(doklink) : () => {}}
        icon={buttonIcon}
        text={'ÅBN PLAN'}
      />

      <LokalplanList
        title="Delområder"
        accentColor={pink[600]}
        bgColor={'#FDF3F8'}
        planer={delomraader}
        onListItemClick={props.onListItemClick}
        onListItemHover={props.onListItemHover}
        hoveredPlans={hoveredPlans}
      />
      <LokalplanList
        title="Byggefelter"
        accentColor={orange[600]}
        bgColor={'#fdfcf3'}
        planer={byggefelter}
        onListItemClick={props.onListItemClick}
        onListItemHover={props.onListItemHover}
        hoveredPlans={hoveredPlans}
      />
    </animated.div>
  );
}

interface ILokalplanDetails {
  lokalplan: ILokalplan;
  selected: boolean;
  onListItemClick: Function;
  onListItemHover: Function;
  hoveredPlans: Array<number>;
}
